import { render, staticRenderFns } from "./RequestsCard.vue?vue&type=template&id=243eab4a&"
import script from "./RequestsCard.vue?vue&type=script&lang=js&"
export * from "./RequestsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports